export const BaseUrl = "https://pflegefinder-portal.de/laravel/public/api/"

export const ImageUrl = "https://pflegefinder-portal.de/laravel/public/"